module.exports = __webpack_public_path__ + "static/hhphone-d0643c38972ece9007b4030b256d4083.jpg";